import type { UtmParams } from 'Types/aemui/utm/utm';

export function getUtmParams(): UtmParams {
	const raw = window.sessionStorage.getItem('utm_params');
	const output: UtmParams = {
		utmAudience: '',
		utmCampaign: '',
		utmContent: '',
		utmImage: '',
		utmMedium: '',
		utmSource: '',
		utmTerm: ''
	};
	let session: Record<string, string[]> = {};
	if (raw) {
		session = JSON.parse(raw) as Record<string, string[]>;
		Object.keys(session).forEach((key) => {
			// format snake case to camel case: utm_term -> utmTerm
			const outputKey = key.includes('utm_')
				? key.slice(0, 3) + key.charAt(4).toUpperCase() + key.slice(5)
				: key;
			if (Object.keys(output).includes(outputKey)) {
				// Append to existing param
				if (output[outputKey as keyof UtmParams]) {
					output[outputKey as keyof UtmParams] += `, ${session[key]!.join(', ')}`;
				} else {
					output[outputKey as keyof UtmParams] = session[key]!.join(', ');
				}
			}
		});
	}

	const params = new URLSearchParams(window.location.search);

	params.forEach((value, key) => {
		// format snake case to camel case: utm_term -> utmTerm
		key = key.includes('utm_') ? key.slice(0, 3) + key.charAt(4).toUpperCase() + key.slice(5) : key;
		value = value?.trim();
		if (!Object.keys(output).includes(key) || !value) {
			return;
		}

		if (output[key as keyof UtmParams].length === 0) {
			output[key as keyof UtmParams] = value;
		} else if (!session[key]?.includes(value)) {
			output[key as keyof UtmParams] += `, ${value}`;
		}
	});

	return output;
}

export const appendUtmData = (utmData: UtmParams, queryString: URLSearchParams) => {
	// From this URL (https://www.lifetime.life/life-time-locations/mn-minnetonka.html?utm_source=facebook&utm_medium=local&utm_campaign=facebook-local-club)
	for (const [key, value] of Object.entries(utmData)) {
		let formattedKey = key;
		if (value) {
			// format to camel case to snake_case: utmTerm -> utm_term
			if (!key.includes('_')) {
				formattedKey = key.slice(0, 3) + '_' + key.charAt(3).toLowerCase() + key.slice(4);
			}
			queryString.append(formattedKey, value);
		}
	}
	return queryString;
};
